import { render, staticRenderFns } from "./latestNews.vue?vue&type=template&id=6256f27a&"
import script from "./latestNews.vue?vue&type=script&lang=js&"
export * from "./latestNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports